import './permission'
import './global'
import './vant'
import '@/styles/index.scss'
import 'lib-flexible/flexible.js'
import '@/icons' // icon
import './vconsole'
import './animate'
